<template>
  <div class="fan-container">
    <div class="layout-banner">
      <img
        src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/index/programme_img.png"
        alt=""
        class="pc-banner"
      />
      <img
        src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/solution_fan_mobile_banner.png"
        class="mobile-banner"
        alt=""
      />
      <div class="text-block">
        <div
          class="title wow fadeInUp"
          data-wow-duration="0.8s"
          data-wow-delay="0.2s"
        >
          风机自动化巡检
        </div>
        <div class="desc wow fadeInUp" data-wow-delay="0.5s">
          无人机全自动飞行，通过模型识别是否含有故障，评定故障类别和严重程度
          30分钟快速生成故障分析报告，分析故障原因，并给出合理化建议
        </div>
      </div>
    </div>

    <div class="block-wrap industry-block">
      <div class="industry-title page-block-title">传统巡检模式分析及问题</div>
      <div class="industry-content pc-carousel">
        <div class="industry-item">
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/problem_fan1.png"
            alt=""
          />
          <div class="text-block">
            <div class="title">巡检效率低、成本高</div>
            <div class="desc">
              传统巡检方式主要依赖人工进行，需要投入大量的人力、物力和财力
            </div>
          </div>
        </div>

        <div class="industry-item">
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/problem_fan2.png"
            alt=""
          />
          <div class="text-block">
            <div class="title">安全隐患大</div>
            <div class="desc">
              风机设备高耸且结构复杂，巡检人员在攀爬、检查过程中容易受伤
            </div>
          </div>
        </div>

        <div class="industry-item">
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/problem_fan3.png"
            alt=""
          />
          <div class="text-block">
            <div class="title">数据准确性差</div>
            <div class="desc">
              巡检人员的经验、判断力和技能水平对巡检结果有较大影响
            </div>
          </div>
        </div>
      </div>
      <div class="mobile-carousel">
        <FanCarousel></FanCarousel>
      </div>
    </div>

    <div class="block-wrap solution-wrap mobile-top">
      <div class="block-title page-block-title">解决思路</div>
      <div class="block-desc">
        基于精准的场站建模与AI识别技术，我们构建了“数据采集→航线规划→自动巡检→AI识别→报告输出”五步闭环流程。全程自动化运行。数据可追溯、缺陷可定位、结果可量化，让风机巡检更安全、更高效、更智能。
      </div>
      <div class="img-wrap">
        <!-- <img
          src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/fan_flow.png"
          class="progress" alt="" /> -->
        <img
          src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/fan_flow.png"
          class="progress"
          alt=""
        />
        <img
          src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/mobile/fan_flow.png"
          class="mobile-progress"
          alt=""
        />
      </div>
    </div>

    <div class="advantage-wrap">
      <div class="advantage-content mobile-top">
        <div class="block-title page-block-title mb-47">我们的优势</div>
        <div class="block-row">
          <div class="block-left wow fadeInLeft" style="width: 60%">
            <img
              src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/fan_advantage1.png"
              alt=""
            />
          </div>
          <div class="block-right wow fadeInRight">
            <div class="block-content">
              <div class="block-content-title">无人机航飞</div>
              <div class="block-list text-block">
                <div class="dot">智能规划</div>
                <div class="dot">自动飞行</div>
                <div class="dot">断点续飞</div>
              </div>
            </div>
          </div>
        </div>

        <div class="block-row">
          <div class="block-left wow fadeInLeft" style="width: 40%">
            <div class="block-content">
              <div class="block-content-title">叶片识别精度</div>
              <div class="block-list text-block">
                <div>能精准捕捉2mm*2mm的叶片缺陷</div>
              </div>
            </div>
          </div>
          <div class="block-right wow fadeInRight" style="width: 60%">
            <img
              src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/fan_advantage2.png"
              alt=""
            />
          </div>
        </div>

        <div class="block-row">
          <div
            class="block-left wow fadeInLeft system-block"
            style="width: 60%"
          >
            <img
              src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/fan_advantage3.png"
              alt=""
            />
          </div>
          <div class="block-right wow fadeInRight">
            <div class="block-content">
              <div class="block-content-title">系统实时分析</div>
              <div class="block-list text-block">
                <div class="dot">智能缺陷分析</div>
                <div class="dot">巡检数据管理</div>
              </div>
            </div>
          </div>
        </div>

        <div class="block-row">
          <div class="block-left wow fadeInLeft" style="width: 40%">
            <div class="block-content">
              <div class="block-content-title">风电缺陷类别</div>
              <div class="block-list text-block">
                <div>
                  可识别结构损坏、叶片雷击、复合层损伤、
                  叶片开裂、胶衣裂纹、表面腐蚀、胶衣脱
                  落、前缘保护膜损伤、表面污染、附件脱 落、表面掉漆等缺陷。
                </div>
              </div>
            </div>
          </div>
          <div class="block-right wow fadeInRight" style="width: 60%">
            <img
              src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/fan_advantage4.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { WOW } from "wowjs";
import FanCarousel from "./components/fan-carousel.vue";

export default {
  components: {
    FanCarousel,
  },
  data() {
    return {};
  },
  mounted() {
    this.$nextTick(() => {
      new WOW().init();
    });
  },
};
</script>

<style lang="stylus" scoped>
.fan-container {
    width:100%;
    @keyframes zoomIn {
            0% {
              transform: scale(1.1);
            }
            100% {
                transform: scale(1);
            }
        }
    .layout-banner {
        position:relative;
        height:100vh;
        img {
          height:100%;
          width: 100%;
          object-fit: cover;
          position: absolute;
          top: 0;
          left: 0;
          z-index: 1;
          transition: transform 0.3s ease-out;
          animation: zoomIn 3s ease-out forwards;
        }
        .text-block {
            position:absolute;
            top:50%;
            left:50%;
            transform: translate(-50%,-50%);
            z-index: 2;
            color:#fff;
            text-align:center;
            .title {
                font-size:3rem;
                letter-spacing: 2px;
                font-weight: bold;
                margin-bottom:1.44rem;
            }
            .desc {
                letter-spacing: 2px;
                width:825px;
                white-space: wrap;
                font-size:1.25rem;
                line-height:35px;
            }
        }
    }
    .advantage-wrap {
        width:100%;
        margin:0 auto 0 auto;
        background-size:cover;
        padding-top:6.18rem;
        padding-bottom:0.93rem;
        .advantage-content {
          max-width:var(--main-width);
          width:84%;
          margin:0 auto;
        }
        .block-title {
            position:relative;
            position:relative;
            text-align:center;
        }
        .mb-47 {
          margin-bottom:2.93rem;
          }
        .block-row {
        display:flex;
        margin-bottom:4.93rem;
        img {
          max-width:100%;
        }
        .system-block {
          width:60%;
        }
        .block-content {
            margin-top:1.875rem;
        }
        .block-left {
            img {

            }
        }
        .block-content-title {
                font-size:1.75rem;
                font-weight:bold;
                color:#2372E9;
                margin-bottom:3.5rem;
            }
            .block-list {
                 div {
                    color:#333;
                    font-size:1rem;
                    margin-bottom:1.5rem;
                    position:relative;
                }
                .dot {
                  padding-left:20px;
                  }
                .dot::after {
                    width: 8px;
                    height: 8px;
                    background: #2372E9;
                    content:"";
                    top:50%;
                    margin-top:-4px;
                    position:absolute;
                    left:1px;
                    border-radius:50%;
                }
            }
        .block-right {
            padding-left:6.3rem;

        }
    }
    }
    .industry-block {
      max-width:var(--main-width);
      width:84%;
      margin:5rem auto 7.12rem;
      .industry-title {
          position:relative;
          position:relative;
          text-align:center;
      }
  .mobile-carousel {
    display:none;
  }
  .industry-content {
      display:flex;
      margin-top:3.06rem;
      flex-wrap:wrap;
      justify-content:center;
      .industry-item {
          width:25%;
          margin-right:33px;
          img {
              margin-bottom:0.875rem;
              width:100%;
              height:auto;
          }
          .text-block {
              text-align:center;
              .title {
                  font-size:1.375rem;
                  font-weight:bold;
                  margin-bottom:10px;
                  color:#333;
              }
              .desc {
               color:#666666;
               font-size:14px;
              }
          }
      }
  }
  }
  .solution-wrap {
    background: linear-gradient( 180deg, rgba(206,228,255,0) 0%, #EFF4FF 100%);
    padding-bottom:67px;
    }
    .block-wrap {
      // max-width:var(--main-width);
      // width:84%;
      // margin:3.6875rem auto 4.93rem;
      display: flex;
      flex-direction: column;
      justify-content: center;
        .block-title {
            position:relative;
            position:relative;
            text-align:center;
        }

    .block-desc {
        font-size: 1rem;
        // max-width:var(--main-width);
        width:930px;
        margin:1.875rem auto 6.06rem;
        line-height:30px;
        letter-spacing:1px;
        color:#666666;
        text-align:center;
        span {
            color:#2372E9;
        }
    }
    .img-wrap {
       width:84%;
      display:flex;
      margin:0 auto;
      justify-content:center;
      img {
        width:85%;
        height:auto;
      }
      }
    .progress {
        // margin-top:7.37rem;
    }

    }
    .mobile-progress {
      display:none;
    }
}
@media only screen and (max-width: 1200px) and (min-width: 768px) {
  .advantage-content {
    max-width:100% !important;
  .block-row {
    flex-wrap:wrap;
    .block-right {
      padding-left:0 !important;
    }
    .block-left,.block-right {
      width:100%;
      display:flex;
      overflow:hidden;
      img {
        width:100%;
      }
    }
  }
}
}
@media only screen and (max-width: 768px) {
.fan-container {
  .pc-carousel{
    display:none !important;
 }
 .mobile-carousel {
   display:block !important;
 }
  .layout-banner {
    height:375px;
    margin-top:108px;
    .text-block {
      margin-top:0 !important;
      width:80%;
      .title {
        font-size:24px;
      }
      .desc {
        width:100%;
        line-height:19px;
        font-size:14px;
      }
    }
    img {
      height:100%;
    }
    }

    .mobile-progress {
      display:block !important;
      width:100% !important;
    }
    .block-wrap {
      width:auto;
      padding:0 20px 42px;
      margin:2rem auto 0;
      .industry-title {
        font-size:22px;
        margin-top:0px;
        font-weight:bold;
      }
      .industry-title::after {
        top:45px !important;
      }
        .block-title {
      font-size: 22px !important;
      font-weight: bold;
      white-space:wrap;
    }
    .block-desc {
      width:95%;
      line-height:19px;
      font-size:14px;
      margin-bottom:15px;
    }
    .block-title::after {
      top:68px !important;
    }
    }
    .mobile-top {
      .block-title::after {
        top:45px !important;
      }
    }
    .fan-mobile-bg {
      width:345px;
    }
    .progress {
      display:none !important;
    }
  .advantage-wrap {
    padding-top:0;
    padding-bottom:0;
  .advantage-content {
    max-width:100%;
    padding:0 15px;
    .block-title{
       margin:30px 0 16px !important
    }
    .block-row:last-child {
      margin-bottom: 20px;
  }
  .block-row {
    flex-wrap:wrap;
    margin:0 0 38px!important;
    .system-block {
      margin-top:32px;
    }
    .block-left,.block-right {
      width:100% !important;
      display:flex;
      padding:0 !important;
      justify-content:left;
      overflow:hidden;
      img {
        width:100% !important;
      }
    }
    .block-content {
      margin-top:19px !important;
      .block-content-title {
        font-size:20px !important;
        margin-bottom:15px !important;
        font-weight:bold;
      }
      .block-list {
        display:flex;
        div {
          margin-right:28px;
          font-size:14px;
        }
      }
    }
  }
  }
  }
}
}
</style>
